<template>
  <div
    class="features-body-layout301 thq-section-padding"
    v-bind:class="rootClassName"
  >
    <div class="features-body-max-width thq-section-max-width">
      <h2 class="features-body-text10 thq-heading-2">
        <slot name="sectionTitle">
          <!--Default content for sectionTitle-->
          <div class="features-body-fragment12">
            <span class="features-body-text15">Features</span>
          </div>
        </slot>
      </h2>
      <p class="features-body-text11 thq-body-large">
        <slot name="sectionTitle11">
          <!--Default content for sectionTitle11-->
          <div class="features-body-fragment14">
            <span class="features-body-text17">
              <span>
                All Natural soaps, made in small batches by Wildwood Herbs
              </span>
              <br />
            </span>
          </div>
        </slot>
      </p>
      <div class="features-body-row thq-grid-auto-300">
        <div class="features-body-feature1">
          <img
            :alt="feature1ImageAlt"
            :src="feature1ImageSrc"
            class="thq-img-ratio-4-3"
          />
          <div class="features-body-content1 thq-flex-column">
            <div class="features-body-section-title1 thq-flex-column">
              <h3 class="features-body-title1 thq-heading-3">
                <slot name="feature1Title">
                  <!--Default content for feature1Title-->
                  <div class="features-body-fragment19">
                    <span class="features-body-text24">Herbal Teas</span>
                  </div>
                </slot>
              </h3>
              <span class="features-body-description1 thq-body-small">
                <slot name="feature1Description">
                  <!--Default content for feature1Description-->
                  <div class="features-body-fragment20">
                    <span class="features-body-text25">
                      Experience the healing properties of our all-natural herbal
                      teas.
                    </span>
                  </div>
                </slot>
              </span>
            </div>
            <div class="features-body-action5 thq-flex-row">
              <button class="thq-button-flat">
                <span class="thq-body-small">
                  <slot name="feature1Button">
                    <!--Default content for feature1Button-->
                    <div class="features-body-fragment15">
                      <span class="features-body-text20">Shop Herbal Teas</span>
                    </div>
                  </slot>
                </span>
                <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                  <path
                    d="M426 256l256 256-256 256-60-60 196-196-196-196z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="features-body-feature2">
          <img
            :alt="feature2ImageAlt"
            :src="feature2ImageSrc"
            class="thq-img-ratio-4-3"
          />
          <div class="features-body-content2 thq-flex-column">
            <div class="features-body-section-title2 thq-flex-column">
              <strong class="features-body-title2 thq-heading-3">
                <slot name="feature2Title">
                  <!--Default content for feature2Title-->
                  <div class="features-body-fragment23">
                    <span class="features-body-text28">Body Butter</span>
                  </div>
                </slot>
              </strong>
              <span class="features-body-description2 thq-body-small">
                <slot name="feature2Description">
                  <!--Default content for feature2Description-->
                  <div class="features-body-fragment18">
                    <span class="features-body-text23">
                      Nourish your skin with our luxurious and organic body
                      butter.
                    </span>
                  </div>
                </slot>
              </span>
            </div>
            <div class="features-body-action6 thq-flex-row">
              <button class="thq-button-flat">
                <span class="thq-body-small">
                  <slot name="feature2Button">
                    <!--Default content for feature2Button-->
                    <div class="features-body-fragment13">
                      <span class="features-body-text16">Shop Body Butter</span>
                    </div>
                  </slot>
                </span>
                <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                  <path
                    d="M426 256l256 256-256 256-60-60 196-196-196-196z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="features-body-feature3">
          <img
            :alt="feature3ImageAlt"
            :src="feature3ImageSrc"
            class="thq-img-ratio-4-3"
          />
          <div class="features-body-content3 thq-flex-column">
            <div class="features-body-section-title3 thq-flex-column">
              <strong class="features-body-title3 thq-heading-3">
                <slot name="feature3Title">
                  <!--Default content for feature3Title-->
                  <div class="features-body-fragment17">
                    <span class="features-body-text22">
                      Consultations with Herbalist
                    </span>
                  </div>
                </slot>
              </strong>
              <span class="features-body-description3 thq-body-small">
                <slot name="feature3Description">
                  <!--Default content for feature3Description-->
                  <div class="features-body-fragment16">
                    <span class="features-body-text21">
                      Get personalized advice and recommendations from our expert
                      herbalist.
                    </span>
                  </div>
                </slot>
              </span>
            </div>
            <div class="features-body-action7 thq-flex-row">
              <button class="thq-button-flat">
                <span class="thq-body-small">
                  <slot name="feature3Button">
                    <!--Default content for feature3Button-->
                    <div class="features-body-fragment24">
                      <span class="features-body-text29">Book Consultation</span>
                    </div>
                  </slot>
                </span>
                <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                  <path
                    d="M426 256l256 256-256 256-60-60 196-196-196-196z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="features-body-feature4">
          <img
            :alt="feature4ImageAlt"
            :src="feature4ImageSrc"
            class="thq-img-ratio-4-3"
          />
          <div class="features-body-content4 thq-flex-column">
            <div class="features-body-section-title4 thq-flex-column">
              <strong class="features-body-title4 thq-heading-3">
                <slot name="feature4Title">
                  <!--Default content for feature4Title-->
                  <div class="features-body-fragment22">
                    <span class="features-body-text27">Gardening Services</span>
                  </div>
                </slot>
              </strong>
              <span class="features-body-description4 thq-body-small">
                <slot name="feature4Description">
                  <!--Default content for feature4Description-->
                  <div class="features-body-fragment11">
                    <span class="features-body-text14">
                      Let us help you create your own herbal garden for a
                      sustainable wellness lifestyle.
                    </span>
                  </div>
                </slot>
              </span>
            </div>
            <div class="features-body-action8 thq-flex-row">
              <button class="thq-button-flat">
                <span class="thq-body-small">
                  <slot name="feature4Button">
                    <!--Default content for feature4Button-->
                    <div class="features-body-fragment21">
                      <span class="features-body-text26">
                        Learn More about Gardening Services
                      </span>
                    </div>
                  </slot>
                </span>
                <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                  <path
                    d="M426 256l256 256-256 256-60-60 196-196-196-196z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <p class="features-body-text12 thq-body-large">
        <slot name="sectionTitle1">
          <!--Default content for sectionTitle1-->
          <div class="features-body-fragment10">
            <span class="features-body-text13">Features</span>
          </div>
        </slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturesBody',
  props: {
    feature3ImageAlt: {
      type: String,
      default: 'Consultations Image',
    },
    feature3ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1675105095678-ac74e1fe3139?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODE3MjQ1Nnw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature2ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1722946533539-c002879d717a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODE3MjQ1NXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature1ImageAlt: {
      type: String,
      default: 'Herbal Teas Image',
    },
    feature4ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1589658346773-0a430cd617b9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODE3MjQ1NXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature2ImageAlt: {
      type: String,
      default: 'Body Butter Image',
    },
    rootClassName: String,
    feature4ImageAlt: {
      type: String,
      default: 'Gardening Services Image',
    },
    feature1ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1606323543591-6d98e249e58d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODE3MjQ1NXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
  },
}
</script>

<style scoped>
.features-body-layout301 {
  gap: var(--dl-layout-space-fiveunits);
  width: 100%;
  height: auto;
  display: flex;
  overflow: hidden;
  position: relative;
  align-items: center;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
}
 
.features-body-max-width {
  gap: var(--dl-layout-space-threeunits);
  display: flex;
  align-items: center;
  flex-direction: column;
}
 
.features-body-text10 {
  text-align: center;
}
 
.features-body-text11 {
  text-align: center;
  border-radius: var(--dl-layout-radius-radius4);
}
 
.features-body-row {
  width: 100%;
}
 
.features-body-feature1 {
  gap: var(--dl-layout-space-twounits);
  flex: 1;
  width: auto;
  display: flex;
  overflow: hidden;
  max-width: 600px;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}
 
.features-body-content1 {
  align-self: stretch;
  align-items: center;
}
 
.features-body-section-title1 {
  align-self: stretch;
  align-items: center;
}
 
.features-body-title1 {
  text-align: center;
}
 
.features-body-description1 {
  text-align: center;
}
 
.features-body-action5 {
  align-self: stretch;
  align-items: stretch;
  justify-content: center;
}
 
.features-body-feature2 {
  gap: var(--dl-layout-space-twounits);
  flex: 1;
  width: auto;
  display: flex;
  overflow: hidden;
  max-width: 600px;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}
 
.features-body-content2 {
  align-self: stretch;
  align-items: center;
}
 
.features-body-section-title2 {
  align-self: stretch;
  align-items: center;
}
 
.features-body-title2 {
  text-align: center;
}
 
.features-body-description2 {
  text-align: center;
}
 
.features-body-action6 {
  align-self: stretch;
  align-items: stretch;
  justify-content: center;
}
 
.features-body-feature3 {
  gap: var(--dl-layout-space-twounits);
  flex: 1;
  width: auto;
  display: none;
  overflow: hidden;
  max-width: 600px;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}
 
.features-body-content3 {
  align-self: stretch;
  align-items: center;
}
 
.features-body-section-title3 {
  align-self: stretch;
  align-items: center;
}
 
.features-body-title3 {
  text-align: center;
}
 
.features-body-description3 {
  text-align: center;
}
 
.features-body-action7 {
  align-self: stretch;
  align-items: stretch;
  justify-content: center;
}
 
.features-body-feature4 {
  gap: var(--dl-layout-space-twounits);
  flex: 1;
  width: auto;
  display: none;
  overflow: hidden;
  max-width: 600px;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}
 
.features-body-content4 {
  align-self: stretch;
  align-items: center;
}
 
.features-body-section-title4 {
  align-self: stretch;
  align-items: center;
}
 
.features-body-title4 {
  text-align: center;
}
 
.features-body-description4 {
  text-align: center;
}
 
.features-body-action8 {
  align-self: stretch;
  align-items: stretch;
  justify-content: center;
}
 
.features-body-text12 {
  text-align: center;
}
 
.features-body-fragment10 {
  display: contents;
}
 
.features-body-text13 {
  display: inline-block;
}
 
.features-body-fragment11 {
  display: contents;
}
 
.features-body-text14 {
  display: inline-block;
}
 
.features-body-fragment12 {
  display: contents;
}
 
.features-body-text15 {
  display: inline-block;
}
 
.features-body-fragment13 {
  display: contents;
}
 
.features-body-text16 {
  display: inline-block;
}
 
.features-body-fragment14 {
  display: contents;
}
 
.features-body-text17 {
  display: inline-block;
}
 
.features-body-fragment15 {
  display: contents;
}
 
.features-body-text20 {
  display: inline-block;
}
 
.features-body-fragment16 {
  display: contents;
}
 
.features-body-text21 {
  display: inline-block;
}
 
.features-body-fragment17 {
  display: contents;
}
 
.features-body-text22 {
  display: inline-block;
}
 
.features-body-fragment18 {
  display: contents;
}
 
.features-body-text23 {
  display: inline-block;
}
 
.features-body-fragment19 {
  display: contents;
}
 
.features-body-text24 {
  display: inline-block;
}
 
.features-body-fragment20 {
  display: contents;
}
 
.features-body-text25 {
  display: inline-block;
}
 
.features-body-fragment21 {
  display: contents;
}
 
.features-body-text26 {
  display: inline-block;
}
 
.features-body-fragment22 {
  display: contents;
}
 
.features-body-text27 {
  display: inline-block;
}
 
.features-body-fragment23 {
  display: contents;
}
 
.features-body-text28 {
  display: inline-block;
}
 
.features-body-fragment24 {
  display: contents;
}
 
.features-body-text29 {
  display: inline-block;
}
 

 
@media(max-width: 991px) {
  .features-body-row {
    width: auto;
    align-items: center;
    flex-direction: column;
  }
  .features-body-feature1 {
    width: 100%;
  }
  .features-body-feature2 {
    width: 100%;
  }
  .features-body-feature3 {
    width: 100%;
  }
  .features-body-feature4 {
    width: 100%;
  }
}
 
@media(max-width: 767px) {
  .features-body-text10 {
    text-align: center;
  }
  .features-body-text11 {
    text-align: center;
  }
  .features-body-text12 {
    text-align: center;
  }
}
 
@media(max-width: 479px) {
  .features-body-max-width {
    gap: var(--dl-layout-space-oneandhalfunits);
  }
}
</style>
